import {WAR_PHASE_STAGES} from '../../../constants/phases';
import {
  selectCurrentPlayer,
  selectUnits,
} from '../../../redux/reducers/sharedStateReducer/selectors';
import {hasAnyUnitWithAdjacentEnemy} from '../hasAdjacentEnemyUnit';
import {checkIfUnitCanShoot} from '../progress/checkIfUnitCanShoot';
import {checkIfUnitCanUseAbility} from '../progress/checkIfUnitCanUseAbility';

/**
 * Пойдет ли сразу за этим этапом войны ближний бой — те же переходы, что в
 * executeWarPhaseStageCompletion (handleCompleteTurn). Нужно клиенту в момент, когда
 * этап уже применен, а смена этапа еще не дошла: по сети это отдельные действия.
 * Итоги боя приходят только со стрельбы, перемещения и манёвра, а манёвр идет после боя.
 *
 * @param {Object} state - корневое состояние с уже примененным этапом
 * @param {string} stage - этап войны
 * @returns {boolean}
 */
export const checkIfMeleeFollowsStage = (state, stage) => {
  const player = selectCurrentPlayer(state);
  const units = selectUnits(state);
  if (!player || !units || !hasAnyUnitWithAdjacentEnemy(player.id, units)) {
    return false;
  }
  if (stage === WAR_PHASE_STAGES.SHOOTING) {
    return true;
  }
  if (stage !== WAR_PHASE_STAGES.MOVEMENT) {
    return false;
  }
  // После перемещения идут способности и стрельба, если есть кому: у игрока будет
  // время закрыть итоги до боя
  return !units
    .filter((unit) => unit.ownerId === player.id)
    .some((unit) => checkIfUnitCanUseAbility(state, unit, player) || checkIfUnitCanShoot(state, unit, player));
};
